import Vue from 'vue'
import vueResource from 'vue-resource'
import constants from '../common/constants'
import session from '../common/session'
import cryptoJs from 'crypto-js'

let vue = new Vue();
Vue.use(vueResource);

const appSecret = 'appsecret';

const objSort = function (obj) {
  let params = '';
  let key;
  let value;
  let keys = Object.keys(obj).sort();
  for (let i in keys) {
    key = keys[i];
    value = obj[keys[i]];
    if (value == null) {
      value = '[""]'
    } else {
      if (key !== 'authorization') {
        value = '["' + value + '"]'
      }
    }
    params += keys[i] + value
  }
  return params
};

const getParams = function (url, parameter) {
  // 用户唯一标识
  let authorization = session.getCurrentSession()['authorization'];
  // 请求头
  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  // 参数
  let params = {};
  for (let key in parameter) {
    if (parameter[key] !== null && parameter[key] !== '' && parameter[key] !== undefined) {
      params[key] = parameter[key]
    }
  }
  let jsonRequest = Object.assign({}, params);
  if (authorization) {
    jsonRequest['authorization'] = authorization;
    headers['authorization'] = authorization
  }
  jsonRequest = objSort(jsonRequest);
  let secret = constants.serverAddress + url + jsonRequest + appSecret;
  headers['sign'] = encodeURIComponent(cryptoJs.enc.Base64.stringify(cryptoJs.HmacSHA256(secret, appSecret)));
  return {
    headers: headers,
    params: params
  }
};

/**
 * GET请求
 */
export function getHttp(interfaceAddress, parameter) {
  let url = constants.serverAddress + interfaceAddress;
  let data = getParams(interfaceAddress, parameter);
  return new Promise((resolve, reject) => {
    vue
      .$http({
        url: url,
        emulateJSON: true,
        params: data.params,
        headers: data.headers,
        method: 'GET'
      })
      .then(response => {
        if (response.data.success === true) {
          resolve(response.data['data'])
        } else {
          reject({message: response.data['errorInfo']})
        }
      }, response => {
        reject(response.data['errorInfo'])
      })
  })
}

/**
 * POST请求
 */
export function postHttp(interfaceAddress, parameter, body) {
  let url = constants.serverAddress + interfaceAddress;
  let data = getParams(interfaceAddress, parameter);
  return new Promise((resolve, reject) => {
    vue
      .$http({
        url: url,
        emulateJSON: true,
        params: data.params,
        headers: data.headers,
        body: JSON.stringify(body),
        method: 'POST'
      })
      .then(response => {
        if (response.data.success === true) {
          resolve(response.data['data'])
        } else {
          reject({message: response.data['errorInfo']})
        }
      }, response => {
        reject(response)
      })
  })
}



// WEBPACK FOOTER //
// ./common/http.js